import React from "react";
import Input from "shared/@forms/Input";

export default function EmailInput({ ...props }) {
  return <Input type="email" {...props} />;
}
